import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { Select, TreeSelect, Tag, Input, Form, Empty, Tooltip, Modal, Divider } from 'antd';
import { apiHolder as api, apis, emailPattern, reDefinedColorListNew, reDefinedColorList, } from 'api';
import { useActions, useAppSelector, useAppDispatch } from '@web-common/state/createStore';
import SiriusModal from '@web-common/components/UI/SiriusModal';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { actions as LoginActions } from '@web-common/state/reducer/loginReducer';
import _remove from 'lodash/remove';
import { isMainAccount } from '@web-mail/util';
import ContactScheduleModal from '@web-common/components/UI/SiriusContact/scheduleModal';
import CircleSubIcon from '@ant-design/icons/MinusCircleFilled';
import CirclePlusIcon from '@ant-design/icons/PlusCircleFilled';
import TriangleDownIcon from '@web-common/components/UI/Icons/svgs/TriangleDown';
import ArrowLeftIcon from '@web-common/components/UI/Icons/svgs/disk/ArrowLeft';
import { AddTagIcon, MailTagIcon, TagCheckedIconInMenu } from '@web-mail/components/MailTagList/Icon';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import { folderIdIsContact, folderNameValidate, getNoRepeatFolderNameByMumber, iconMap, operCheck, getTreeStatesByAccount } from '@web-mail/util';
import classNames from 'classnames';
import MobileBindModal from '@web-account/Login/modal/bindMobile';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { TagModal } from '@web-mail/components/MailTagList/MailTag';
import styles from './mailAction.module.scss';
import useGetFolderTree from './useGetFolderTree';
import { getIn18Text } from 'api';
import { useForwardEmailPolicy } from '@web-common/hooks/useForwardEmailPolicy';
const { Option } = Select;
const { TextArea } = Input;
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const systemApi = api.api.getSystemApi();
const ignoreKeys = ['__delivery__', '__deliveryrecord__'];
export var mailActionEnum;
(function (mailActionEnum) {
    mailActionEnum["move"] = "move";
    mailActionEnum["forward"] = "forward";
    mailActionEnum["notice"] = "notice";
    mailActionEnum["tags"] = "tags";
    mailActionEnum["top"] = "top";
    mailActionEnum["read"] = "read";
    mailActionEnum["flags"] = "flags";
    mailActionEnum["reply"] = "reply";
    mailActionEnum["reject"] = "reject";
    mailActionEnum["validation"] = "validation";
})(mailActionEnum || (mailActionEnum = {}));
export const ProductVersionMap = {
    sirius: getIn18Text('ZUNXIANGBAN'),
    ultimate: getIn18Text('QIJIANBAN'),
    education: getIn18Text('XIAOYUANBAN'),
    standard_1g: getIn18Text('BIAOZHUNBAN'),
    standard_3g: getIn18Text('SHANGWUBAN'),
    free: getIn18Text('MIANFEIBAN'),
    others: getIn18Text('QITABANBEN'),
};
var mailActionValue;
(function (mailActionValue) {
    mailActionValue[mailActionValue["move"] = getIn18Text('YIDONGYOUJIANZHI')] = "move";
    mailActionValue[mailActionValue["tags"] = getIn18Text('TIANJIABIAOQIAN')] = "tags";
    mailActionValue[mailActionValue["top"] = getIn18Text('SHEWEIZHIDINGYOU')] = "top";
    mailActionValue[mailActionValue["flags"] = getIn18Text('TIANJIAHONGQI')] = "flags";
    mailActionValue[mailActionValue["read"] = getIn18Text('BIAOWEIYIDU')] = "read";
    mailActionValue[mailActionValue["reply"] = getIn18Text('ZIDONGHUIFU')] = "reply";
    mailActionValue[mailActionValue["reject"] = getIn18Text('JUSHOU')] = "reject";
})(mailActionValue || (mailActionValue = {}));
const ADD_FOLDER_ID = -999;
const tag = '[MailTagsTree]';
const AutoReply = ({ replyMsg, onChange }) => {
    useEffect(() => () => {
        onChange('');
    }, []);
    const onContentChange = useCallback(e => {
        var _a;
        console.log(tag, 'onContentChange', e);
        onChange((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
    }, []);
    return (React.createElement(Form.Item, { name: "action_reply", rules: [
            {
                validator: (_, value) => {
                    if (!value || (value === null || value === void 0 ? void 0 : value.trim()) === '') {
                        return Promise.reject(new Error(getIn18Text('QINGSHURUNEIRONG')));
                    }
                    return Promise.resolve();
                },
            },
        ] },
        React.createElement(TextArea, { className: styles.txtReply, placeholder: getIn18Text('QINGSHURUNEIRONG'), autoFocus: true, onChange: onContentChange, value: replyMsg, maxLength: 2000, autoSize: { minRows: 1, maxRows: 10 } })));
};
const MailFolderDropdown = props => {
    const { selectedKey, treeList, onSelect, onAddFolder } = props;
    const treeListPlus = useMemo(() => {
        return treeList.concat([
            {
                childrenCount: 0,
                entry: {
                    mailBoxName: getIn18Text('XINJIANWENJIANJIA'),
                    mailBoxId: ADD_FOLDER_ID,
                },
            },
        ]);
    }, [treeList]);
    const [selectedMenuKey, setSelectedMenuKey] = useState(selectedKey);
    const ref = useRef(null);
    const onSelectMenuFid = useCallback(key => {
        var _a;
        setSelectedMenuKey(key);
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
    }, [setSelectedMenuKey]);
    const ckFootAdd = () => {
        const entry = {
            mailBoxName: getIn18Text('XINJIANWENJIANJIA'),
            mailBoxId: ADD_FOLDER_ID,
        };
        onAddFolder(entry);
    };
    const renderTreeNodeTitle = (node) => {
        const isAddFolder = node.mailBoxId === ADD_FOLDER_ID;
        const isCustomFolder = node.mailBoxId >= 100;
        const eventBind = {
            onClick: (e) => {
                e.stopPropagation();
                onAddFolder(node);
            },
        };
        return (React.createElement("div", Object.assign({ className: styles.dropdownNodeWrap }, (isAddFolder ? eventBind : {})),
            React.createElement("div", { className: styles.dropdownNodeName },
                isAddFolder ? React.createElement(ReadListIcons.AddFolderSvg, null) : React.createElement(ReadListIcons.FolderSvg, null),
                React.createElement("span", { className: classNames(styles.dropdownNodeText, isAddFolder ? styles.dropdownNodeTextBlue : '') }, node.mailBoxName)),
            React.createElement("div", { className: styles.operWrap },
                React.createElement(Tooltip, { title: getIn18Text('XINJIANZIWENJIAN'), trigger: ['hover'] },
                    React.createElement("div", { className: styles.dropdownTreeAdd, onClick: e => {
                            e.stopPropagation();
                            onAddFolder(node);
                        } },
                        React.createElement(AddTagIcon, null))))));
    };
    const data2tree = (list) => {
        const array = [-1, -9, 17, 19];
        return _remove(list.slice(), item => array.indexOf(item.entry.mailBoxId) < 0 && !folderIdIsContact(item.entry.mailBoxId) && item.entry.mailBoxId > 0).map(data => {
            var _a, _b;
            const treeNode = {
                key: data.entry.mailBoxId,
                value: data.entry.mailBoxId,
                label: renderTreeNodeTitle(data.entry),
                isLeaf: !((_a = data.children) === null || _a === void 0 ? void 0 : _a.length),
                icon: iconMap.get((_b = data.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId),
                selectable: data.entry.mailBoxId !== ADD_FOLDER_ID,
            };
            if (!treeNode.isLeaf && data.children && data.children.length > 0) {
                treeNode.children = data2tree(data.children);
            }
            return treeNode;
        });
    };
    const list = useMemo(() => data2tree(treeListPlus), [treeList]);
    useEffect(() => () => {
        setSelectedMenuKey(undefined);
        onSelect(undefined);
    }, []);
    const tagRender = (props) => {
        const { label } = props;
        return (React.createElement("div", { className: styles.mailFolderLabel },
            React.createElement("span", { className: styles.mailFolderTxt }, label)));
    };
    return (React.createElement(Form.Item, { name: "action_choose_folder", initialValue: selectedMenuKey, rules: [{ required: true, message: getIn18Text('QINGXUANZEWENJIAN') }] },
        React.createElement(TreeSelect, { ref: ref, getPopupContainer: node => node.parentElement, suffixIcon: React.createElement(TriangleDownIcon, null), showSearch: false, style: { width: '100%' }, tagRender: tagRender, mode: "tags", maxTagCount: 1, placeholder: getIn18Text('XUANZEWENJIANJIA'), treeData: list, onSelect: onSelectMenuFid, dropdownRender: menu => (React.createElement(React.Fragment, null,
                menu,
                React.createElement("div", { className: styles.footAdd, onClick: ckFootAdd },
                    React.createElement(ReadListIcons.AddFolderSvg, null),
                    React.createElement("span", { className: styles.footAddText }, getIn18Text('XINJIANWENJIANJIA'))))) })));
};
const MailTagsTree = props => {
    const { selectedKeys, onSelect, onAddTag, tagList } = props;
    const onChange = useCallback(e => {
        console.log(tag, 'onChange', e);
        onSelect(e);
    }, []);
    useEffect(() => () => {
        onSelect([]);
    }, []);
    const tagRender = (props) => {
        var _a, _b, _c;
        const { value, onClose } = props;
        return (React.createElement(Tag, { color: (_a = tagList.get(value)) === null || _a === void 0 ? void 0 : _a.color, key: value, className: styles.selectTag, closeIcon: React.createElement("div", { className: styles.tagExtra, onClick: () => {
                    onClose && onClose();
                }, style: { backgroundColor: (_b = tagList.get(value)) === null || _b === void 0 ? void 0 : _b.color } },
                React.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M2.25 7.75L5 5M5 5L2.25 2.25M5 5L7.75 7.75M5 5L7.75 2.25", stroke: "white", strokeLinejoin: "round" }))), closable: true, onClose: onClose, style: { color: (_c = tagList.get(value)) === null || _c === void 0 ? void 0 : _c.fontColor, marginRight: 3 } }, value));
    };
    const addItem = useCallback(e => {
        e.preventDefault();
        onAddTag();
    }, [onAddTag]);
    return (React.createElement(Form.Item, { name: "action_tags", rules: [
            { required: true, message: getIn18Text('QINGXUANZEBIAOQIAN') },
            {
                validator: (_, value) => {
                    if (value instanceof Array && value.length > 10) {
                        return Promise.reject(new Error(getIn18Text('ZUIDUOXUANZE1')));
                    }
                    return Promise.resolve();
                },
            },
        ], initialValue: selectedKeys },
        React.createElement(Select, { suffixIcon: React.createElement(TriangleDownIcon, null), mode: "multiple", className: styles.tagSelectTree, filterOption: false, tagRender: tagRender, onChange: onChange, notFoundContent: React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: getIn18Text('ZANWUBIAOQIAN') }), placeholder: getIn18Text('QINGXUANZEBIAOQIAN'), defaultValue: selectedKeys, getPopupContainer: node => node.parentElement, dropdownMatchSelectWidth: false, dropdownStyle: { minWidth: 200 }, menuItemSelectedIcon: React.createElement(TagCheckedIconInMenu, null), listHeight: 166, dropdownRender: menu => (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.tagDropdownLabel },
                    React.createElement("span", null, getIn18Text('XUANZEBIAOQIAN'))),
                menu,
                React.createElement(Divider, { style: { margin: '4px 5px' } }),
                React.createElement("div", { className: styles.tagCreate, onClick: addItem },
                    React.createElement("span", { className: styles.tagCreateIcon },
                        React.createElement(AddTagIcon, null)),
                    React.createElement("span", { className: styles.tagOptionSpan }, getIn18Text('TIANJIABIAOQIAN'))))) }, Array.from(tagList).map(([key, item]) => (React.createElement(Option, { value: key, key: key },
            React.createElement("div", { className: styles.tagOption },
                React.createElement(MailTagIcon, { className: "tag-icon", strokeColor: item.originColor, checked: selectedKeys.includes(key) }),
                React.createElement("span", { className: styles.tagOptionSpan }, key))))))));
};
const ForwardMail = props => {
    const { selectedKey, form } = props;
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [resetKey, setResetKey] = useState(0);
    const { maxCount, isWhitelisted, isInOwnDomain } = useForwardEmailPolicy();
    const [hasExternalEmail, setHasExternalEmail] = useState(false);
    const checkExternal = useCallback((items) => {
        const has = isWhitelisted && items.some((item) => (item === null || item === void 0 ? void 0 : item.email) && !isInOwnDomain(item.email));
        setHasExternalEmail(has);
    }, [isWhitelisted, isInOwnDomain]);
    const handleRemoveExternal = useCallback(() => {
        const values = form.getFieldValue('action_forward') || [];
        const filtered = values.filter((item) => !(item === null || item === void 0 ? void 0 : item.email) || isInOwnDomain(item.email));
        form.setFieldsValue({ action_forward: filtered });
        setSelectedKeys(filtered);
        setHasExternalEmail(false);
        setResetKey(k => k + 1);
        setTimeout(() => form.validateFields(['action_forward']), 0);
    }, [isInOwnDomain, form]);
    const handleChange = useCallback((items) => {
        checkExternal(items || []);
    }, [checkExternal]);
    useEffect(() => {
        let isMounted = true;
        if (selectedKey) {
            const emails = selectedKey
                .split(',')
                .map(s => s.trim())
                .filter(Boolean);
            contactApi
                .doGetContactByItem({
                type: 'EMAIL',
                value: emails,
                filterType: 'enterprise',
                _account: accountApi.getCurrentAccount().email,
            })
                .then(res => {
                if (!isMounted)
                    return;
                let resolved = res.map(itm => {
                    var _a, _b;
                    return ({
                        name: (_a = itm === null || itm === void 0 ? void 0 : itm.contact) === null || _a === void 0 ? void 0 : _a.contactName,
                        email: (_b = itm === null || itm === void 0 ? void 0 : itm.contact) === null || _b === void 0 ? void 0 : _b.accountName,
                    });
                });
                if (!resolved.length) {
                    resolved = emails.map(email => ({ name: email, email }));
                }
                else {
                    const resolvedEmails = new Set(resolved.map(r => r.email));
                    emails.forEach(email => {
                        if (!resolvedEmails.has(email)) {
                            resolved.push({ name: email, email });
                        }
                    });
                }
                setSelectedKeys(resolved);
                checkExternal(resolved);
            });
        }
        return () => {
            isMounted = false;
        };
    }, [selectedKey]);
    return (React.createElement("div", { className: styles.forwardNodeWrap },
        React.createElement("span", { className: styles.forwardDescGray }, getIn18Text('ZHUANFADAOYOUXIANG')),
        React.createElement(Form.Item, { key: resetKey, name: "action_forward", rules: [
                { required: true, message: getIn18Text('QINGSHURUNEIRONG') },
                {
                    validator: (_, value) => {
                        var _a, _b;
                        if (!Array.isArray(value)) {
                            return Promise.resolve();
                        }
                        const trimValueList = value.filter((item) => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.email) === null || _a === void 0 ? void 0 : _a.trim(); });
                        const character1 = (trimValueList === null || trimValueList === void 0 ? void 0 : trimValueList.find((item) => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.email) === null || _a === void 0 ? void 0 : _a.indexOf('\\')) > -1; })) ? '\\' : '';
                        const character2 = (trimValueList === null || trimValueList === void 0 ? void 0 : trimValueList.find((item) => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.email) === null || _a === void 0 ? void 0 : _a.indexOf('"')) > -1; })) ? '"' : '';
                        if (character1 && character2) {
                            return Promise.reject(new Error(`不支持保存特殊字符${character1}和${character2}，请修改`));
                        }
                        if (character1 || character2) {
                            return Promise.reject(new Error(`不支持保存特殊字符${character1 || character2}，请修改`));
                        }
                        if ((trimValueList === null || trimValueList === void 0 ? void 0 : trimValueList.length) > maxCount) {
                            return Promise.reject(new Error(isWhitelisted ? getIn18Text('最多输入20个邮箱') : getIn18Text('NEIRONGBUDECHAO1')));
                        }
                        if (trimValueList && ((_a = trimValueList[0]) === null || _a === void 0 ? void 0 : _a.email) && !emailPattern.test((_b = trimValueList[0]) === null || _b === void 0 ? void 0 : _b.email)) {
                            return Promise.reject(new Error(getIn18Text('YOUXIANGGESHICUO1')));
                        }
                        if (isWhitelisted) {
                            const invalidEmail = trimValueList.find((item) => (item === null || item === void 0 ? void 0 : item.email) && !isInOwnDomain(item.email));
                            if (invalidEmail) {
                                checkExternal(trimValueList);
                                return Promise.reject(new Error(getIn18Text('仅支持本企业域名邮箱')));
                            }
                        }
                        checkExternal(trimValueList);
                        return Promise.resolve();
                    },
                },
            ], initialValue: selectedKeys },
            React.createElement(ContactScheduleModal, { includeSelf: true, hideAvatar: true, unSelect: true, multiRow: true, allowClear: true, repeatToast: true, defaultSelectList: selectedKeys, placeholder: getIn18Text('KESHURUYOUXIANG'), style: { minHeight: 32 }, characterLimit: 50, onChange: handleChange })),
        hasExternalEmail && (React.createElement("span", { className: styles.forwardDescOperate, style: { flexShrink: 0, marginLeft: 8, whiteSpace: 'nowrap', lineHeight: '32px' }, onClick: handleRemoveExternal }, getIn18Text('删除域外邮箱')))));
};
const ForwardValidation = props => {
    const { _account } = props;
    let timer;
    const [codeLoadingCount, setCodeLoadingCount] = useState(0);
    const [value, setValue] = useState('');
    const getCode = async () => {
        if (codeLoadingCount !== 0) {
            return;
        }
        let count = 60;
        setCodeLoadingCount(count);
        const res = await accountApi.doSendVerificationCode(_account);
        if (res.success) {
            if ((res === null || res === void 0 ? void 0 : res.count) <= 0) {
                SiriusMessage.error({ content: getIn18Text('YANZHENGMAHUOQUSHIBAI') });
                setCodeLoadingCount(0);
                return;
            }
            timer = setInterval(() => {
                if (count > 0) {
                    count -= 1;
                    setCodeLoadingCount(count);
                }
                else {
                    clearInterval(timer);
                    setCodeLoadingCount(0);
                }
            }, 1000);
        }
        else {
            SiriusMessage.error({ content: res.error });
            setCodeLoadingCount(0);
        }
    };
    useEffect(() => () => {
        setValue('');
        setCodeLoadingCount(0);
        clearInterval(timer);
    }, []);
    return (React.createElement(Form.Item, { name: "action_forward_validation", rules: [{ required: true, message: getIn18Text('QINGSHURUYANZHENG') }] },
        React.createElement("div", { className: styles.validationNodeWrap },
            React.createElement("span", { className: styles.forwardDescGray }, getIn18Text('YANZHENGMA')),
            React.createElement(Input, { value: value, onChange: e => setValue(e.target.value.replace(/[^0-9]+/g, '')), className: styles.forwardInput, placeholder: getIn18Text('QINGSHURUDUANXIN'), maxLength: 6 }),
            codeLoadingCount ? (React.createElement("span", { className: styles.forwardDescGray },
                codeLoadingCount,
                getIn18Text('sHOUKEZHONGXINHUOQU'))) : (React.createElement("span", { className: styles.forwardDescOperate, onClick: () => getCode() }, getIn18Text('MIANFEIHUOQUYANZHENGMA'))))));
};
export const CreateMailFolderModal = ({ node, visible, setVisible, createSuccess, _account }) => {
    const [folderName, setFolderName] = useState(getIn18Text('WEIMINGMINGWENJIAN'));
    const dispatch = useAppDispatch();
    const inputRef = React.useRef(null);
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    useEffect(() => {
        if (visible) {
            setFolderName(node.folderName);
            setTimeout(() => {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus({
                    cursor: 'all',
                });
            }, 200);
        }
    }, [visible]);
    const handleOk = useCallback(() => {
        if (!folderNameValidate(folderName)) {
            return;
        }
        setConfirmLoading(true);
        dispatch(Thunks.createUserFolder([
            {
                parent: node.mailBoxId,
                name: folderName,
                accountId: _account,
            },
        ])).then(res => {
            var _a;
            setConfirmLoading(false);
            if (res.meta.requestStatus === 'fulfilled') {
                SiriusMessage.success({ content: getIn18Text('TIANJIACHENGGONG') });
                createSuccess((_a = res.payload) === null || _a === void 0 ? void 0 : _a.res[0]);
                setVisible(false);
                setFolderName('');
            }
        });
    }, [node, folderName]);
    const handleCancel = () => {
        console.log('Clicked cancel button');
        setVisible(false);
    };
    return (React.createElement(Modal, { wrapClassName: styles.mailAction, closable: false, className: styles.newFolderModal, okText: getIn18Text('QUEDING'), cancelText: getIn18Text('QUXIAO'), mask: false, maskClosable: false, title: React.createElement("div", { className: styles.newFolderTitle, onClick: handleCancel },
            React.createElement("span", { className: styles.backIcon },
                React.createElement(ArrowLeftIcon, null)),
            React.createElement("span", { className: styles.title }, node.mailBoxId == ADD_FOLDER_ID ? getIn18Text('XINJIANWENJIANJIA') : getIn18Text('XINJIANZIWENJIAN'))), centered: true, style: { height: 213, width: 400 }, visible: visible, onOk: handleOk, confirmLoading: confirmLoading, onCancel: handleCancel },
        React.createElement("div", { className: styles.newFolderDesc, hidden: node.mailBoxId == ADD_FOLDER_ID },
            getIn18Text('ZAI'),
            React.createElement("span", { className: styles.parentFolderSpan },
                React.createElement(ReadListIcons.FolderSvg, null),
                node.mailBoxName.length > 20 ? `${node.mailBoxName.substring(0, 20)}...` : node.mailBoxName),
            getIn18Text('ZHONGXINJIANZIWEN')),
        React.createElement("div", { className: styles.newFolderInput },
            React.createElement(Input, { ref: inputRef, autoFocus: true, maxLength: 40, placeholder: getIn18Text('QINGSHURUWENJIAN'), value: folderName, onChange: e => {
                    setFolderName(e.target.value);
                } }))));
};
export const MailAction = props => {
    var _a, _b, _c, _d, _e, _f;
    const { onActionSelect = () => { }, onSubModalVisible = () => { }, actions = [], selectedAction, setSelectedAction, form, _account, isScopeSent } = props;
    const isThirdAccount = ((_b = (_a = systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.authAccountType) !== '0';
    const actionOps = isThirdAccount
        ? [mailActionEnum.move, mailActionEnum.tags, mailActionEnum.flags, mailActionEnum.read]
        : [mailActionEnum.move, mailActionEnum.tags, mailActionEnum.top, mailActionEnum.flags, mailActionEnum.read, mailActionEnum.reply];
    const mailTreeStateMap = useAppSelector(state => state.mailReducer.mailTreeStateMap);
    const mailTagList = useMemo(() => {
        const folderState = getTreeStatesByAccount(mailTreeStateMap || '', _account);
        if (folderState && (folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList)) {
            return folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList;
        }
        return [];
    }, [mailTreeStateMap]);
    const [actionsVisible, setActionsVisible] = useState(true);
    const [mailMoveFolderVal, setMailMoveFoldernVal] = useState();
    const [selectedTags, setSelectedTags] = useState([]);
    const [selectedForward, setSelectedForward] = useState('');
    const [replyMsg, setReplyMsg] = useState('');
    const [mailTagMap, setMailTagMap] = useState(new Map());
    const treeList = useGetFolderTree(_account);
    const [newfolerModalVisible, setNewfolerVisible] = useState(false);
    const [nodeFolder, setNodeFolder] = useState({ pid: -2, mailBoxId: -2, mailBoxName: '' });
    const [addTagModalVisible, setAddTagVisible] = useState(false);
    const [accountInfo, setAccountInfo] = useState({});
    const { setVisibleMobileBindModal } = useActions(LoginActions);
    const [msgRemain, setMsgRemain] = useState(0);
    const [msgUsed, setMsgUsed] = useState(0);
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const setNewfolerModalVisible = (visible) => {
        onSubModalVisible(visible);
        setNewfolerVisible(visible);
    };
    const setAddTagModalVisible = (visible) => {
        onSubModalVisible(visible);
        setAddTagVisible(visible);
    };
    const tag = '[MailAction]';
    useEffect(() => () => {
        [mailActionEnum.reject, mailActionEnum.move, mailActionEnum.reply, mailActionEnum.tags, mailActionEnum.forward].forEach(resetActionFieldVal);
    }, []);
    useEffect(() => {
        if (actions.length > 0) {
            const backfillSelect = [];
            actions.forEach((action) => {
                switch (action.type) {
                    case mailActionEnum.tags:
                        backfillSelect.unshift(mailActionEnum.tags);
                        setSelectedTags(action.value);
                        form.setFieldsValue({ action_tags: action.value });
                        break;
                    case mailActionEnum.reply:
                        backfillSelect.unshift(mailActionEnum.reply);
                        form.setFieldsValue({ action_reply: action.content });
                        break;
                    case mailActionEnum.flags:
                        if (action.disabled) {
                            break;
                        }
                        if (action.value.read) {
                            backfillSelect.unshift(mailActionEnum.read);
                        }
                        if (action.value.top) {
                            backfillSelect.unshift(mailActionEnum.top);
                        }
                        if (action.value.label0) {
                            backfillSelect.unshift(mailActionEnum.flags);
                        }
                        break;
                    case mailActionEnum.move:
                        if (action.disabled) {
                            break;
                        }
                        backfillSelect.unshift(mailActionEnum.move);
                        setMailMoveFoldernVal(Number(action.target));
                        form.setFieldsValue({ action_choose_folder: Number(action.target) });
                        break;
                    case mailActionEnum.reject:
                        form.setFieldsValue({ action_type: 'reject' });
                        setActionsVisible(false);
                        break;
                    case mailActionEnum.notice:
                        backfillSelect.push(mailActionEnum.notice);
                        form.setFieldsValue({ action_type: 'notice' });
                        break;
                    case mailActionEnum.forward:
                        backfillSelect.unshift(mailActionEnum.forward);
                        setSelectedForward(action.target);
                        form.setFieldsValue({
                            action_type: 'forward',
                            action_forward: (action.target || '')
                                .split(',')
                                .map((s) => s.trim())
                                .filter(Boolean)
                                .map((email) => ({ name: email, email })),
                        });
                        break;
                    default:
                        break;
                }
            });
            setSelectedAction([...backfillSelect]);
        }
    }, [actions]);
    const mountedRef = useRef(true);
    useEffect(() => () => {
        mountedRef.current = false;
    }, []);
    const getAccountBindAndForwardInfo = async () => {
        const res = await accountApi.doGetAccountBindAndForwardInfo(_account);
        if (mountedRef.current) {
            (res === null || res === void 0 ? void 0 : res.bindInfo) && setAccountInfo(res);
        }
    };
    useEffect(() => {
        getAccountBindAndForwardInfo();
        getAccCusSetting();
    }, []);
    useEffect(() => {
        if (isScopeSent) {
            setSelectedAction([mailActionEnum.move]);
            form.setFieldsValue({ action_type: 'normal' });
            setActionsVisible(true);
        }
    }, [isScopeSent]);
    const onFolderDropdownChange = useCallback(selectedKey => {
        console.log(tag, getIn18Text('YOUJIANYIDONGZHI'), selectedKey);
        setMailMoveFoldernVal(selectedKey);
    }, []);
    const onTagSelect = useCallback((tags) => {
        console.log(tag, getIn18Text('BIAOQIANBIANHUA'), tags);
        setSelectedTags(tags);
    }, []);
    const onMailFolderAdd = useCallback((node) => {
        console.log(tag, 'onMailFolderAdd', node);
        if (!operCheck(treeList, node)) {
            return;
        }
        const folderNode = Object.assign(Object.assign({}, node), { folderName: getNoRepeatFolderNameByMumber(treeList, node.mailBoxId, getIn18Text('WEIMINGMINGWENJIAN'), node.mailBoxId) });
        setNodeFolder(folderNode);
        setNewfolerModalVisible(true);
    }, [treeList]);
    const onActionChange = useCallback((actionName) => {
        switch (actionName) {
            case 'normal':
                setActionsVisible(true);
                setSelectedAction([mailActionEnum.move]);
                break;
            case 'notice':
                if (productVersionId !== 'sirius') {
                    setActionsVisible(true);
                    setSelectedAction([mailActionEnum.move]);
                    form.setFieldsValue({ action_type: 'normal' });
                    SiriusModal.info({
                        title: getIn18Text('SHENGJIYOUXIANGBANBEN'),
                        content: (React.createElement("div", null,
                            getIn18Text('DANGQIANBANBENWEI：'),
                            ProductVersionMap[productVersionId],
                            getIn18Text('，RUXUSHIYONGZHONGYAO'))),
                        okText: getIn18Text('QUEDING'),
                        closable: true,
                        isGlobal: true,
                        onOk: () => { },
                    });
                }
                else {
                    setActionsVisible(true);
                    setSelectedAction([mailActionEnum.notice]);
                }
                break;
            case 'forward':
                setActionsVisible(true);
                setSelectedAction([mailActionEnum.forward]);
                break;
            case 'reject':
                onActionSelect([{ type: 'reject' }]);
                setActionsVisible(false);
                setSelectedAction([mailActionEnum.reject]);
                break;
            default:
                break;
        }
    }, [productVersionId]);
    const onNormalActionChange = useCallback((actionName, index) => {
        setSelectedAction(state => {
            const list = [...state];
            resetActionFieldVal(list[index]);
            list.splice(index, 1, actionName);
            onActionSelect(list);
            return list;
        });
    }, [onActionSelect]);
    const onReplyChange = useCallback((content) => {
        console.log(tag, getIn18Text('BIAOQIANBIANHUA'), content);
        setReplyMsg(content);
    }, []);
    const onMailFolderCreated = useCallback((mailFolderBoxId) => {
        console.log('onMailFolderCreated', mailFolderBoxId);
        if (mailFolderBoxId) {
            form.setFieldsValue({ action_choose_folder: mailFolderBoxId });
            onActionSelect(selectedAction);
        }
    }, [onActionSelect]);
    const resetActionFieldVal = (actionName) => {
        switch (actionName) {
            case mailActionEnum.move:
                form.setFieldsValue({ action_choose_folder: undefined });
                break;
            case mailActionEnum.reply:
                form.setFieldsValue({ action_reply: '' });
                break;
            case mailActionEnum.tags:
                form.setFieldsValue({ action_tags: [] });
                break;
            case mailActionEnum.reject:
                form.setFieldsValue({ action_type: 'normal' });
                break;
            case mailActionEnum.forward:
                form.setFieldsValue({ action_forward: '' });
                break;
        }
    };
    const options = useMemo(() => {
        mailTagList.forEach((item) => {
            const tagKey = item[0];
            if (!mailTagMap.has(item[0]) && !ignoreKeys.includes(tagKey)) {
                const strokeColor = reDefinedColorListNew.find(innerItem => { var _a; return innerItem.nums.includes((_a = item[1]) === null || _a === void 0 ? void 0 : _a.color); });
                const originTag = reDefinedColorList.find(innerItem => { var _a; return innerItem.nums.includes((_a = item[1]) === null || _a === void 0 ? void 0 : _a.color); });
                const colorClassName = (strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.className) || 'color1';
                const originColor = (originTag === null || originTag === void 0 ? void 0 : originTag.color) || '#6BA9FF';
                const tagFontColor = (strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.fontColor) || '#fff';
                mailTagMap.set(item[0], { color: strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.color, originColor, fontColor: tagFontColor, class: colorClassName });
            }
        });
        setMailTagMap(mailTagMap);
        return mailTagMap;
    }, [mailTagList === null || mailTagList === void 0 ? void 0 : mailTagList.length]);
    const onOperationChange = useCallback((index, actionName) => {
        if (actionName && selectedAction.includes(actionName)) {
            if (selectedAction.length > 1) {
                resetActionFieldVal(actionName);
                setSelectedAction(state => {
                    const list = [...state].filter(item => item !== actionName);
                    onActionSelect(list);
                    return list;
                });
            }
        }
        else {
            const newAction = actionOps.find(item => !selectedAction.includes(item));
            if (newAction) {
                setSelectedAction(state => {
                    const list = [...state];
                    if (list.length - 1 === index) {
                        list.push(newAction);
                    }
                    else {
                        list.splice(index + 1, 0, newAction);
                    }
                    onActionSelect(list);
                    return list;
                });
            }
        }
    }, [selectedAction, setSelectedAction, onActionSelect]);
    const onTagAdded = useCallback(tagName => {
        setTimeout(() => {
            setSelectedTags(tags => {
                const _tags = [...tags, tagName];
                form.setFieldsValue({ action_tags: _tags });
                return _tags;
            });
        }, 500);
    }, [form, setSelectedTags]);
    const alertMsgRemain = useMemo(() => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.alertMsgText5 },
            React.createElement("span", { className: styles.alertMsgDesc }, getIn18Text('TIXINGYUL')),
            msgRemain,
            getIn18Text('TIAO'),
            msgRemain < 11 && React.createElement("span", { className: styles.alertMsgRemain },
                " ",
                getIn18Text('NINDEYULBZJYLXGLY'))),
        React.createElement("div", { className: styles.alertMsgText5 },
            React.createElement("span", { className: styles.alertMsgDesc }, getIn18Text('TIXINGYISY')),
            msgUsed,
            getIn18Text('TIAO')))), [msgRemain, msgUsed]);
    const generateActionSlot = (actionName) => {
        let rcSlot = React.createElement(React.Fragment, null);
        switch (actionName) {
            case mailActionEnum.move:
                rcSlot = React.createElement(MailFolderDropdown, { treeList: treeList, onSelect: onFolderDropdownChange, onAddFolder: onMailFolderAdd, selectedKey: mailMoveFolderVal });
                break;
            case mailActionEnum.reply:
                rcSlot = React.createElement(AutoReply, { onChange: onReplyChange, replyMsg: replyMsg });
                break;
            case mailActionEnum.tags:
                rcSlot = React.createElement(MailTagsTree, { selectedKeys: selectedTags, tagList: options, onAddTag: () => setAddTagModalVisible(true), onSelect: onTagSelect });
                break;
            case mailActionEnum.forward:
                rcSlot = React.createElement(ForwardMail, { selectedKey: selectedForward, form: form });
                break;
            case mailActionEnum.notice:
                rcSlot = alertMsgRemain;
                break;
            case mailActionEnum.validation:
                rcSlot = React.createElement(ForwardValidation, { _account: _account });
        }
        return rcSlot;
    };
    const mobileBindSuccess = () => {
        setVisibleMobileBindModal(false);
        getAccountBindAndForwardInfo();
    };
    const getAccCusSetting = async () => {
        try {
            const res = await mailConfApi.getAccCusSetting();
            if (res) {
                const { orgOpen, accSetting } = res;
                if (accSetting) {
                    const { smsQuotaUsed, smsQuotaLeft } = accSetting;
                    setMsgRemain(smsQuotaLeft);
                    setMsgUsed(smsQuotaUsed);
                }
            }
        }
        catch (error) {
            console.log('getAccCusSetting error', error);
        }
    };
    const mailActionRef = useRef(null);
    return (React.createElement("div", { className: styles.mailAction, ref: mailActionRef },
        React.createElement("div", { className: styles.actionDesc },
            React.createElement("span", { className: styles.actionLabel }, getIn18Text('ZEZHIXING')),
            React.createElement(Form.Item, { name: "action_type", initialValue: "normal", style: { display: isScopeSent ? 'none' : 'inline-block', marginBottom: 0 } },
                React.createElement(Select, { getPopupContainer: node => node.parentElement, suffixIcon: React.createElement(TriangleDownIcon, null), defaultValue: "normal", style: { width: 163 }, onChange: onActionChange },
                    React.createElement(Option, { value: "normal" }, getIn18Text('PUTONGGUIZE')),
                    !isThirdAccount && (React.createElement(React.Fragment, null,
                        (!_account || isMainAccount(_account)) && (React.createElement(Option, { value: "notice" },
                            getIn18Text('ZHONGYAOYOUJIANTIX'),
                            React.createElement("span", { className: styles.VVIP }, getIn18Text('ZUNXIANGBAN')))),
                        React.createElement(Option, { value: "forward", disabled: ((_c = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.forwardInfo) === null || _c === void 0 ? void 0 : _c.fwd) !== 1 },
                            React.createElement(Tooltip, { title: ((_d = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.forwardInfo) === null || _d === void 0 ? void 0 : _d.fwd) !== 1 ? getIn18Text('ZANWUQUANXIAN，QINGLIAN') : '', placement: "right", getPopupContainer: () => mailActionRef.current }, getIn18Text('ZHUANFADAOQITAYOUXIANG'))),
                        React.createElement(Option, { value: "reject" }, getIn18Text('JUSHOU')))))),
            isScopeSent && React.createElement("span", { style: { marginLeft: 8 } }, getIn18Text('YIDONGYOUJIANZHI'))),
        actionsVisible ? (React.createElement("div", { className: styles.actionListDiv }, selectedAction.map((item, index, list) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (item === mailActionEnum.notice) {
                if (!((_a = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.bindInfo) === null || _a === void 0 ? void 0 : _a.mobile)) {
                    return (React.createElement("div", { className: styles.actionItemBind },
                        React.createElement("p", { className: styles.actionItemBindTitle }, getIn18Text('BANGDINGSHOUJIHAO')),
                        React.createElement("p", { className: styles.actionItemBindDesc }, getIn18Text('ZHONGYAOYOUJIANGUANJIA')),
                        React.createElement("p", { className: styles.actionItemBindBtn, onClick: () => setVisibleMobileBindModal(true) }, getIn18Text('LIJIBANGDING'))));
                }
                return (React.createElement("div", { className: classNames(styles.actionItemBinded, styles.actionItemBindedTip) },
                    alertMsgRemain,
                    React.createElement("div", { className: styles.forwardMobileWrap },
                        React.createElement("span", { className: styles.forwardDescGray }, getIn18Text('BANGDINGSHOUJIHAO')),
                        React.createElement("div", null,
                            React.createElement("span", { className: styles.forwardDescMobile }, (_c = (_b = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.bindInfo) === null || _b === void 0 ? void 0 : _b.mobile) === null || _c === void 0 ? void 0 : _c.slice(-11).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')),
                            React.createElement("span", { className: styles.forwardDescOperate, onClick: () => setVisibleMobileBindModal(true) }, getIn18Text('XIUGAI')),
                            React.createElement("span", { className: styles.forwardDescGrayLight }, getIn18Text('WEIBIMIANZHONGYAOXINXI'))))));
            }
            if (item === mailActionEnum.forward) {
                if (((_d = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.forwardInfo) === null || _d === void 0 ? void 0 : _d.fwdmauth) !== 1) {
                    return (React.createElement("div", { className: styles.actionItemBinded },
                        React.createElement("div", { className: styles.itemSlot }, generateActionSlot(item))));
                }
                if (!((_e = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.bindInfo) === null || _e === void 0 ? void 0 : _e.mobile)) {
                    return (React.createElement("div", { className: styles.actionItemBind },
                        React.createElement("p", { className: styles.actionItemBindTitle }, getIn18Text('BANGDINGSHOUJIHAO')),
                        React.createElement("p", { className: styles.actionItemBindDesc }, getIn18Text('WEILEBIMIANZIDONGZHUAN')),
                        React.createElement("p", { className: styles.actionItemBindBtn, onClick: () => setVisibleMobileBindModal(true) }, getIn18Text('LIJIBANGDING'))));
                }
                return (React.createElement("div", { className: classNames(styles.actionItemBinded, styles.actionItemBindedTip) },
                    React.createElement("div", { className: styles.itemSlot }, generateActionSlot(item)),
                    React.createElement("div", { className: styles.forwardMobileWrap },
                        React.createElement("span", { className: styles.forwardDescGray }, getIn18Text('BANGDINGSHOUJIHAO')),
                        React.createElement("div", null,
                            React.createElement("span", { className: styles.forwardDescMobile }, (_g = (_f = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.bindInfo) === null || _f === void 0 ? void 0 : _f.mobile) === null || _g === void 0 ? void 0 : _g.slice(-11).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')),
                            React.createElement("span", { className: styles.forwardDescOperate, onClick: () => setVisibleMobileBindModal(true) }, getIn18Text('XIUGAI')),
                            React.createElement("span", { className: styles.forwardDescGrayLight }, getIn18Text('WEIBIMIANZHONGYAOXINXI')))),
                    React.createElement("div", { className: styles.itemSlot }, generateActionSlot(mailActionEnum.validation))));
            }
            if (isScopeSent && item === mailActionEnum.move) {
                return (React.createElement(Form.Item, { name: 'action_type_' + item, initialValue: item, className: styles.actionFormItem },
                    React.createElement("div", { className: styles.actionItem },
                        React.createElement("div", { className: styles.itemSlot }, generateActionSlot(item)))));
            }
            return (React.createElement(Form.Item, { name: 'action_type_' + item, initialValue: item, className: styles.actionFormItem },
                React.createElement("div", { className: styles.actionItem },
                    React.createElement(Select, { getPopupContainer: node => node.parentElement, suffixIcon: React.createElement(TriangleDownIcon, null), defaultValue: item, key: item + index, className: styles.itemSelect, onChange: value => onNormalActionChange(value, index) }, actionOps.map((action) => {
                        return (React.createElement(Option, { disabled: action !== item && selectedAction.includes(action), value: action }, mailActionValue[action]));
                    })),
                    React.createElement("div", { className: styles.itemSlot }, generateActionSlot(item)),
                    React.createElement("div", { className: styles.itemOperationBtn, onClick: () => {
                            onOperationChange(index, item);
                        } },
                        React.createElement(CircleSubIcon, { style: { color: 'rgb(163, 164, 169)', opacity: list.length === 1 ? 0.5 : 1 } })),
                    React.createElement("div", { className: styles.itemOperationBtn, onClick: () => {
                            onOperationChange(index);
                        } },
                        React.createElement(CirclePlusIcon, { style: { color: 'rgb(56, 110, 231)', opacity: list.length === actionOps.length ? 0.5 : 1 } })))));
        }))) : null,
        React.createElement(MobileBindModal, { isBind: !((_e = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.bindInfo) === null || _e === void 0 ? void 0 : _e.mobile), isUpdate: !!((_f = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.bindInfo) === null || _f === void 0 ? void 0 : _f.mobile), onSuccess: () => mobileBindSuccess() }),
        React.createElement(CreateMailFolderModal, { createSuccess: onMailFolderCreated, node: nodeFolder, setVisible: setNewfolerModalVisible, visible: newfolerModalVisible, _account: _account }),
        addTagModalVisible && (React.createElement(TagModal, { type: "add", data: [], container: document.body, markWhenAdd: false, mask: false, maskClosable: false, onTagAdded: onTagAdded, account: _account, afterClose: () => {
                setAddTagModalVisible(false);
            } }))));
};
